<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br>
    
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table :headers="headers" :items="increment_year_list" class="elevation-1 mytable" :search="search">
      <template v-slot:top>
        <v-toolbar class="toolbar" flat color="white">
          <v-toolbar-title>Increment Year</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row dense>
          <v-col cols="12" sm="3" md="3">
            <v-btn color="success" outlined rounded v-if="increment_year_list.length != 0">
              <download-excel class="mr-2 pb-3 pt-2" :data="increment_year_list" :fields="table_fields"
                worksheet="PayRollIncrementYear" name="PayRollIncrementYear.xls">
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn>
          </v-col>
          <v-col sm="6" md="4" cols="12">
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
          </v-col>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="mb-2 button" v-on="on">Add Increment Year</v-btn>
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.name" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: 2020-2021'
                              : 'For example :: 2020-2021'
                          " label="Enter Year" :rules="[(v) => !!v || 'required']" rounded outlined dense>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete dense v-model="editedItem.year_id" :items="year_list" label="Increment Year"
                          item-text="name" item-value="id" single-line rounded outlined
                          :rules="[(v) => !!v || 'required']"></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field persistent-hint hint="Inclusive" placeholder="Inclusive" color="#0F2027"
                              v-model="editedItem.fromdate" outlined rounded dense label="From Date Date"
                              prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                              :rules="[(v) => !!v || 'required']"></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.fromdate" @input="menu1 = false">
                          </v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field persistent-hint hint="Inclusive" placeholder="Inclusive" color="#0F2027"
                              v-model="editedItem.todate" outlined rounded dense label="To Date"
                              prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                              :rules="[(v) => !!v || 'required']">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.todate" @input="menu2 = false">
                          </v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                  <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "Increment Year", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    menu1: false,
    menu2: false,
    errorMsg: {
      castId: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Increment Year",
        align: "left",
        sortable: false,
        value: "year_name",
      },
      {
        text: "From Date",
        align: "left",
        sortable: false,
        value: "fromdate",
      },
      {
        text: "To Date",
        align: "left",
        sortable: false,
        value: "todate",
      },
      {
        text: "Is Active?",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      Name: "name",
      "Increment Year": "year_name",
      "From Date": "fromdate",
      "To Date": "todate",
    },
    year_list: [],
    increment_year_list: [],
    editedIndex: -1,
    editedItem: {
      incrementyearId: "",
      name: "",
      year_name: "",
      year_id: "",
      fromdate: "",
      todate: "",
      isActive: true,
    },
    defaultItem: {
      incrementyearId: "",
      name: "",
      year_name: "",
      year_id: "",
      fromdate: "",
      todate: "",
      isActive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Increment Year"
        : "Edit Increment Year";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/getIncrementYearList")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.increment_year_list = res.data.increment_year_list;
              this.year_list = res.data.year_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.increment_year_list.indexOf(item);
      this.dialog = true;
      this.editedItem.name = item.name;
      this.editedItem.fromdate = item.fromdate;
      this.editedItem.todate = item.todate;
      this.editedItem.isActive = item.isactive;
      this.editedItem.year_id = item.year_id;
      this.editedItem.year_name = item.year_name;
      this.editedItem.incrementyearId = item.id;
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      var regex = /[a-z]/i;
      if (regex.test(this.editedItem.name)) {
        this.showSnackbar("#b71c1c", "Year Cannot Have Any Alphabets"); // show snackbar on success
      } else {
        if (this.editedIndex > -1) {
          if (this.isValidated()) {
            axios
              .post("/Payroll/editIncrementYear", this.editedItem)
              .then((res) => {
                if (res.data.status.code == "200") {
                  //   Object.assign(
                  //     this.increment_year_list[this.editedIndex],
                  //     this.editedItem
                  //   );
                  this.showSnackbar("#4caf50", "Year Updated Successfully..."); // show snackbar on success
                  this.onLoad();
                } else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Year Already Present!!!"); // show snackbar on error
                }
              })
              .catch((error) => {
                window.console.log(error);
              });
            this.close();
          }
        } else {
          //window.alert(JSON.stringify(this.editedItem))
          axios
            .post("/Payroll/saveIncrementYear", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "200") {
                this.showSnackbar("#4caf50", "Year Added Successfully..."); // show snackbar on success
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "Year Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.incrementyearId) {
        return true;
      } else {
        if (!this.editedItem.incrementyearId) {
          this.errorMsg.castId = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>